if(document.querySelector('.interior-page__sidebar')){
  $(window).on('scroll', function() {
    const sidebar = document.querySelector('.interior-page__sidebar'),
          sidebarWrapper = $('.left-sidebar__wrapper'),
          screenWidth = window.innerWidth,
          headerHeight = screenWidth < 1024 ? 60 : 150,
          sidebarHeight = sidebarWrapper.height(),
          currentPositionTop = sidebar.getBoundingClientRect().top,
          currentPositionBottom = sidebar.getBoundingClientRect().bottom,
          isSticky = currentPositionTop < headerHeight,
          isBottom = currentPositionBottom < (headerHeight + sidebarHeight);

    if (isBottom && screenWidth >= 1024) {
      sidebarWrapper.removeClass("sticky-sidebar");
      sidebarWrapper.addClass("sticky-bottom-sidebar");
    } else if (isSticky) {
      if(screenWidth < 1024) {
        $('.site-header').hide();
      }

      sidebarWrapper.removeClass("sticky-bottom-sidebar");
      sidebarWrapper.addClass("sticky-sidebar");
    } else {
      if(screenWidth < 1024) {
        $('.site-header').show();
      }

      sidebarWrapper.removeClass("sticky-bottom-sidebar");
      sidebarWrapper.removeClass("sticky-sidebar");
    }
  });

  $('.left-sidebar__dropdown').click(function() {
    const sidebarDropdown = $(this),
          sidebarContent = $(this).parent().find('.left-sidebar__content');
  
    if(sidebarDropdown.hasClass('open')){
      sidebarDropdown.removeClass('open');
      sidebarContent.css('max-height', 0);
    } else {
      sidebarDropdown.addClass('open');
      sidebarContent.css('max-height', sidebarContent.prop('scrollHeight') + 'px');
    }
  });
}
